<template>
  <div id="app">
    <img class="bg-img" :src="backImg" alt="" />
    <div class="content">
      <!-- 여기에 내용 추가 -->
       <p>더 나은 서비스를 위해 사이트를 개선하고 있습니다.</p>
    </div>
  </div>
</template>

<script>
import backImg from './assets/main.png'

export default {
  name: 'App',
  data() {
    return {
      backImg
    }
  }
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
html, body {
  width: 100%;
}
#app {
  position: relative;
  width: 100%;
}
#app .bg-img {
  width: 100%;
  height: auto;
  display: block;
}
#app .content {
  position: absolute;
  top: 14%;
  left: 50%;
  transform: translateX(-50%);
  text-align: center;
  white-space: nowrap;
}
#app .content p {
  color: #FFF;
  font-size: clamp(14px, 2.5vw, 40px);
  font-weight: 700;
}
</style>
